<!--
	PS-6495 — the dialog is only a frame; every behaviour lives in app-guided-setup.

	Deliberately NOT `mat-dialog-content`: that class carries `max-height: 65vh` and `overflow: auto`,
	so the panel scrolled inside a dialog that had room to grow — scrollbars on content that fits.
	The component sizes to its content and scrolls only past the viewport limit set in the SCSS.
-->
<app-guided-setup
	(contactService)="onContactService()"
	(dismissed)="onDismissed()"
	(failed)="onFailed($event)"
	(ready)="onReady($event)"
	(suspended)="onSuspended()"
	[availableNumbers]="data.availableNumbers"
	[expectedPhoneServiceId]="data.expectedPhoneServiceId"
	[locale]="lang"
	[monthlyCost]="data.monthlyCost"
	[sipOnOffer]="data.sipOnOffer"
	[signals]="data.signals"
></app-guided-setup>
